module.exports = __webpack_public_path__ + "static/lunchtype22-medium-webfont-b84681525669adea4d31a24504e887b3.woff2";